"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'voices.magdalena.description': 'Low-pitched, warm with calm strength and subtlety.',
};
